export default __webpack_public_path__ + "static/media/file-upload.7d1e2234.svg";